/*

Adds inputs

*/
import MediaStreamPreview from "../MediaStreamPreview";
import "../style.css";
import {
  CiStreamOn,
  CiStreamOff,
  CiMaximize1,
  CiMinimize1,
  CiEdit,
  CiTrash,
} from "react-icons/ci";

// Button for maximizing/minimizing this MediaStream
// Shows magnifying glass when not editable, else a pencil
const PreviewButton = (props) => {
  let text;
  if (props.isPreview) {
    text = <CiMinimize1 className="iconSize" />;
  } else {
    if (props.isEditable) {
      text = <CiEdit className="iconSize" />;
    } else {
      text = <CiMaximize1 className="iconSize" />;
    }
  }
  if (props.isPreview) {
    return (
      <button
        className="media-button flex-item flex-grow nopad noborder media-button-active"
        style={{
          borderTopLeftRadius: "0.5em",
          border: "1px solid rgb(255, 255, 255)",
        }}
        onClick={props.clearPreview}
      >
        {text}
      </button>
    );
  } else {
    return (
      <button
        className="media-button flex-item flex-grow nopad noborder"
        onClick={props.setCurrentSteam}
        style={{ borderTopLeftRadius: "0.5em" }}
      >
        {text}
      </button>
    );
  }
};

// Button for starting or stopping a broadcast for this MediaStream
const BroadcastButton = (props) => {
  if (props.isBroadcasting) {
    return (
      <button
        className="media-button flex-item flex-grow nopad noborder media-button-active"
        onClick={props.removeBroadcast}
      >
        <CiStreamOn className="iconSize" />
      </button>
    );
  } else {
    if (props.isAtLimit) {
      return (
        <button
          className="flex-item flex-grow nopad noborder"
          disabled
          style={{ border: "1px solid rgb(255, 255, 255)" }}
        >
          <CiStreamOff className="iconSize" />
        </button>
      );
    } else {
      return (
        <button
          className="media-button flex-item flex-grow nopad noborder"
          onClick={props.startBroadcast}
          style={{ border: "1px solid rgb(255, 255, 255)" }}
        >
          <CiStreamOff className="iconSize" />
        </button>
      );
    }
  }
};

// Button for removing this MediaStream
const RemoveButton = (props) => {
  return (
    <button
      className="media-button flex-item flex-grow nopad noborder"
      // style={{ color: "green" }}
      onClick={props.removeStream}
      style={{ borderTopRightRadius: "0.5em", color: "#c73333" }}
    >
      <CiTrash className="iconSize" style />
    </button>
  );
};

const StreamButton = (props) => {
  // Starts a push for the given MediaStream
  const startBroadcast = () => {
    props.startBroadcast(props.streamObj, "webrtc", "");
  };

  const removeBroadcast = () => {
    props.removeBroadcast(props.streamObj);
  };

  const setCurrentSteam = () => {
    props.setCurrentSteam(props.streamObj);
  };

  const removeStream = () => {
    props.removeStream(props.mediaIndex);
  };

  return (
    <div
      className="container"
      style={{ marginTop: "1em", marginBottom: "2em" }}
    >
      <div
        className="flex-parent"
        style={{
          borderTopRightRadius: "0.5em",
          borderTopLeftRadius: "0.5em",
          height: "3em",
        }}
      >
        <PreviewButton
          isPreview={props.isPreview}
          isEditable={props.streamObj.editable}
          setCurrentSteam={setCurrentSteam}
          clearPreview={props.clearPreview}
        />
        <BroadcastButton
          isBroadcasting={props.isBroadcasting}
          startBroadcast={startBroadcast}
          removeBroadcast={removeBroadcast}
          isAtLimit={props.isAtLimit}
        />
        <RemoveButton removeStream={removeStream} />
      </div>
      <div
        className="flex-parent"
        style={{
          border: "2px solid rgb(0, 0, 0)",
          borderBottomLeftRadius: "0.5em",
          borderBottomRightRadius: "0.5em",
        }}
      >
        <MediaStreamPreview
          stream={props.streamObj.mediaSourceRef.current}
          roundedBottoms={true}
        />
      </div>
    </div>
  );
};

export default StreamButton;
